/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllCampaigns = async (clientId?: number) => {
    // Explicitly handle null, undefined, 0, and NaN cases
    const url = (clientId != null && !isNaN(clientId) && clientId !== 0) ? `/campaign/all?clientId=${clientId}` : '/campaign/all';
    // Send the GET request
    const response = await http.get(url);
    // Return the response
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignDetailsById = async (campaignId: number) => {
    const response = await http.get(`/campaign/${campaignId}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const addNewCampaign = async (data: any) => {
    const response = await http.post(`/campaign/add`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const updateNewCampaign = async (data: any) => {
    const response = await http.put(`/campaign/update`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const deleteCampaign = async (data: any) => {
    const response = await http.delete(`/campaign/delete`, { data: data });
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const changeStatusCampaign = async (data: any) => {
    const response = await http.post(`/campaign/active`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const copyCampaign = async (data: any) => {
    const response = await http.post(`/campaign/copy`, data); // Directly pass data without wrapping in 'data'
    return response;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignReportData = async (campaignId: any, fromDate?: any, toDate?: any, statusId?: any, type?: any) => {
    let response;
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if(fromDate && toDate) {
        
        if(type === 'bulkemail') {
            response = await http.get(`/campaign/Report/Download/${campaignId}?fromDate=${fromDate}&toDate=${toDate}&statusId=${statusId}&type=${type}`);
        } else {
            response = await http.get(`/campaign/Report/Download/${campaignId}?fromDate=${fromDate}&toDate=${toDate}&statusId=${statusId}`);
        }
        
        return response;
    }
    if(type === 'bulkemail') {
        response = await http.get(`/campaign/Report/Download/${campaignId}?type=${type}`);
    } else {
        response = await http.get(`/campaign/Report/Download/${campaignId}`);
    }
    
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const updateCampaignTestMode = async (data: any) => {
    const response = await http.post(`/campaign/changetestmode`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignReportCardCounts = async (campaignId: any, clientId: any, startDate: any, endDate: any, status: any, type: any) => {
    
    const params = new URLSearchParams();
    params.append('clientId', clientId);
    params.append('campaignId', campaignId);
    params.append('status', status);
    if(type) {
        params.append('type', type);
    }

    if(type && type === 'listtrigger') {
        params.append('listTriggerId', campaignId);
    }
    // Only add dates if both exist
    if (startDate && endDate) {
        params.append('fromDate', startDate);
        params.append('toDate', endDate);
    }
  const response = await http.get(`/campaign/dashboard/cardcounts?${params.toString()}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignReportDomainCount = async (campaignId: any, clientId: any, startDate: any, endDate: any, status: any, type: any, heatmapEventFilter: any) => {
     const params = new URLSearchParams();
        params.append('clientId', clientId);
        params.append('campaignId', campaignId);
        params.append('status', status);
        params.append('heatmapEventFilter', heatmapEventFilter);
        if(type) {
            params.append('type', type);
        }
        if(type && type === 'listtrigger') {
            params.append('listTriggerId', campaignId);
        }
        // Only add dates if both exist
        if (startDate && endDate) {
        params.append('fromDate', startDate);
        params.append('toDate', endDate);
        }
    const response = await http.get(`/campaign/dashboard/domaincounts?${params.toString()}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignReportDeviceCount = async (campaignId: any, clientId: any, startDate: any, endDate: any, status: any, type: any) => {
     const params = new URLSearchParams();
        params.append('clientId', clientId);
        params.append('campaignId', campaignId);
        params.append('status', status);
        if(type) {
            params.append('type', type);
        }
        if(type && type === 'listtrigger') {
            params.append('listTriggerId', campaignId);
        }
        // Only add dates if both exist
        if (startDate && endDate) {
        params.append('fromDate', startDate);
        params.append('toDate', endDate);
        }
    const response = await http.get(`/campaign/dashboard/devicecounts?${params.toString()}`);
    return response;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getResendStatus = async (campaignId?: any, listTriggerId?: any, type?: any) => {
    const queryParams = [];

    if (campaignId) queryParams.push(`id=${campaignId}`);
    if (listTriggerId) queryParams.push(`id=${listTriggerId}`);

    queryParams.push(`campaignType=${type}`);

    const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

    const response = await http.get(`/campaign/getresendstatus${queryString}`);
    return response;
};

//Export Custom Report
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCustomFieldData = async () => {
    const response = await http.get(`/report/getcustomnpifields`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const exportCustomFieldReport = async (data: any, type?: any) => {
    if(type === 'bulkemail') {
        const response = await http.post(`/report/customnpireportcampaign?type=${type}`, data);
        return response;
    }
    const response = await http.post(`/report/customnpireportcampaign`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const exportStandardReport = async (campaignId: any, type?: any) => {
    if(type === 'bulkemail') {
        const response = await http.get(`/report/standardnpireportcampaign/${campaignId}?type=${type}`);
        return response;
    }
    const response = await http.get(`/report/standardnpireportcampaign/${campaignId}`);
    return response;
}


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getCampaignReportCategoryCount = async (
  campaignId: any,
  clientId: any,
  startDate: any,
  endDate: any,
  status: any,
  type: any
) => {
  const params = new URLSearchParams();

  params.append('clientId', clientId);
  params.append('campaignId', campaignId);
  params.append('status', status);
  if(type) {
        params.append('type', type);
    }
    if(type && type === 'listtrigger') {
        params.append('listTriggerId', campaignId);
    }
  // Only add dates if both exist
    if (startDate && endDate) {
        params.append('fromDate', startDate);
        params.append('toDate', endDate);
    }

  const response = await http.get(`/campaign/dashboard/categorycounts?${params.toString()}`);
  return response;
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllBulkCampaigns = async (clientId?: number) => {
    // Explicitly handle null, undefined, 0, and NaN cases
    const url = (clientId != null && !isNaN(clientId) && clientId !== 0) ? `/bulkcampaign/all?clientId=${clientId}` : '/bulkcampaign/all';
    // Send the GET request
    const response = await http.get(url);
    // Return the response
    return response;
}